import { DOCUMENT } from "@angular/common";
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { authenticationGuard } from "~modules/shared/guard/authentication.guard";
import { Error404PageComponent } from "~modules/shared/pages/error404-page/error404-page.component";
import { appPaths } from "./app.routes";
import { authInterceptor } from "./modules/shared/interceptors/app.interceptor";
export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(HttpClient),
    provideAnimationsAsync(),
    provideRouter([
      {
        path: appPaths.home,
        loadChildren: () =>
          import("./modules/mattress-foam/mattress-foam.routes").then(
            (mod) => mod.MATTRESS_FOAM_ROUTES,
          ),
        pathMatch: "full",
        canActivate: [authenticationGuard],
      },
      {
        path: appPaths.auth,
        loadChildren: () =>
          import("./modules/auth/auth.routes").then((mod) => mod.AUTH_ROUTES),
      },
      { path: "404", component: Error404PageComponent },
      { path: "**", redirectTo: "404" },
    ]),
    { provide: Document, useExisting: DOCUMENT },
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
